export default theme => ({

    root: {
        backgroundColor:"white",
        alignItems: 'center', position: 'absolute', top: '25%', left: '20%', right:"20%"
      },
      textGrey:{
        color:"#66788A"
      },
    
  });
  
  